<template>
  <div  v-if="show"
      :style="{'background': nameToColor(), 'height': circleHeight + 'px', 'width': circleWidth + 'px', 'font-size': fontSize}"
      style="border-radius: 50%; color: white; padding: 0 4px;"
      :title="username" class="text-center"
    >
    {{ username ? username.charAt(0).toUpperCase() : '' }}
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';
import Vuex from 'vuex'

export default {
  name: 'ks-circle',
  props:  {
    username: {
      type: String,
      required: true
    },
    showIfNoUserName: {
      type: Boolean,
      default: false
    },
    circleHeight: {
      type: Number,
      default: 20
    },
    circleWidth: {
      type: Number,
      default: 19
    },
    fontSize: {
      type: String,
      default: 'small'
    },
    showOnlyInMultiCampaign : {
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...Vuex.mapGetters({selected_campaigns: 'rms_ui/auth/selected_campaigns'}),
    show(){
      let userValidate = this.username || (!this.username && this.showIfNoUserName);
      return this.showOnlyInMultiCampaign ? this.selected_campaigns.length > 1 && userValidate : userValidate;
    }
  },
  methods: {
    nameToColor() {
      function hashCode(str) { // java String#hashCode
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
      }
      function intToRGB(i) {
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();
        return "00000".substring(0, 6 - c.length) + c;
      }
      return '#' + intToRGB(hashCode(this.username));
    }
  }
}
</script>